var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Apexcharts',{ref:"chart",attrs:{"type":"bar","options":_vm.options,"series":_vm.series,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }